import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import {
    Dialog,
    Button,
    makeStyles,
    Grid,
    FormHelperText
} from '@material-ui/core';
import { DialogTitle, DialogContent, DialogActions } from '../Dialog/Dialog';
import { Autocomplete } from 'mui-rff';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Form } from 'react-final-form';
import { checkNumberOnly } from "../../../utils/utils";
import { getDieselCardDriverList, generateFuelCard, updateVehicle3 } from "../../../store/actions/vehicleActionCreator";
import * as logger from "../../../logger";
import AddEditNewDriver from './AddEditNewDriver';
import { useHistory } from "react-router-dom";


const useStyles = makeStyles((theme) => ({

    divTitle: {
        color: 'rgba(11, 19, 35, 0.5)',
        fontSize: 12,
        textAlign: 'left',
        fontWeight: 600
    },
    divContainer: {
        backgroundColor: '#ededed',
        border: '1px solid #dcdcdc',
        borderRadius: 8,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 16,
        paddingBottom: 16
    },
    mlV1: {
        marginLeft: 4
    },
    truckNumberContainer: {
        display: 'flex',
        fontWeight: 'bold',
        fontSize: 16,
        marginTop: 4
    },
    listBoxAutoCompelete: {
        margin: 0,
        padding: 0,
        maxHeight: '30vh'
    },
    listBoxOption: {
        padding: 0,
        borderBottom: '1px solid #eaedf3',
        "&:first-child": {
        },
        "&:last-child": {
        }
    },
    titleBullet: {
        borderRadius: "50%",
        backgroundColor: "lightgrey",
        fontSize: 8,
        color: "lightgrey",
        margin: "0px 6px",
        marginTop: -2
    },
    driverAddListItem: {
        padding: '12px 15px',
        margin: 0,
        backgroundColor: '#e3e8fd',
        color: '#5170f0',
        fontWeight: 300,
        minHeight: 46,
        width: '100%',
        maxHeight: 46
    },
    addPersonIcon: {
        color: '#5170f0',
        marginRight: 10
    },
    cherveRightIcon: {
        marginLeft: 10,
        float: 'right',
        color: '#5170f0'
    },
    brV1: {
        borderRadius: 8
    },
    mt24: {
        marginTop: 24
    },
    formControlPropsRoot: {
        marginTop: '4px !important',
        marginBottom: '0px !important'
    },
    autoCompleteRoot: {
        "& .MuiFormControl-marginNormal": {
            marginTop: '4px !important',
            marginBottom: '0px !important'
        }
    },
    inputRootV1: {
        backgroundColor: 'white !important'
    },
    dialogContent: {
        backgroundColor: '#f6f6f8 '
    },
    titleV1: {
        color: 'rgba(11, 19, 35, 0.75)',
        fontWeight: 600
    },
    saveCta: {
        backgroundColor: '#09101e',
        borderRadius: '4px',
        color: 'white',
        textTransform: 'none',
        fontSize: 14,
        boxShadow: 'none !important',
        "&:hover": {
            backgroundColor: '#09101e'
        }
    },
    disableCta: {
        backgroundColor: '#dadada',
        fontSize: 14,
        color: '#5e636c',
        borderRadius: 4,
        textTransform: 'none',
        boxShadow: 'none !important',
        "&: hover": {
            backgroundColor: '#dadada'
        }
    },
    driverListItem: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 20,
        paddingRight: 20
    },
    helperText: {
        marginTop: 4,
        color: 'rgba(11, 19, 35, 0.75)',
        fontSize: 12,
        fontWeight: 300
    }
}))

const filter = createFilterOptions({
    limit: 30
});

function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

const DriverDetailsDialog = ({ open, onClose, truckInfo, vehicle, dispatchGetDieselCardDriverList, dispatchGenerateFuelCard, dispatchUpdateVehicle, fromSingleTruck }) => {

    let submit;
    let history = useHistory();


    const [dialogOpen, setDialogOpen] = useState(open);
    const [driverValue, setDriverValue] = useState(truckInfo && truckInfo.driverId ? truckInfo.driverId : null);
    const [addDriverOpen, toggleAddDriverOpen] = useState(false);
    const [dataFlag, setDataFlag] = useState(false);
    // const [newDriverName, setNewDriverName] = useState("");
    const [fuelCardDriverList, setFuelCardDriverList] = useState([]);
    const [driverFlow, setDriverFlow] = useState(null);
    const [verifyDriver, setVerifyDriver] = useState(null);

    const vehicleNumberArray = fromSingleTruck ? (truckInfo.vehicleNumberArrayDweb ? truckInfo.vehicleNumberArrayDweb : []) : (truckInfo.vehicleNumArrayValue ? truckInfo.vehicleNumArrayValue : [])

    const initialValues = {
        driver: driverValue
    }

    useEffect(() => {
        handleRecallDriverList();
    }, []);

    useEffect(() => {

        if (vehicle && vehicle.fuelCardDriverList) {
            setFuelCardDriverList(vehicle.fuelCardDriverList)
        }

    }, [vehicle.fuelCardDriverList]);

    useEffect(() => {

        if (driverValue) {
            const driverDetails = (vehicle.fuelCardDriverList).find((driverInfo) => driverInfo.id == driverValue)

            if (driverDetails && !driverDetails.contactNumber) {
                toggleAddDriverOpen(true);
                setDriverFlow("verify")
                setVerifyDriver(driverDetails);
            }

        }

    }, [driverValue, vehicle.fuelCardDriverList]);

    const classes = useStyles();

    const handleClose = () => {
        setDialogOpen(false);
        onClose()
        vehicle.fuelCardDriverList = []
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mt24}>
                            <div className={classes.titleV1}>Driver*</div>
                            {fuelCardDriverList && fuelCardDriverList.length > 0 &&
                                <Autocomplete
                                    classes={{
                                        listbox: classes.listBoxAutoCompelete,
                                        option: classes.listBoxOption,
                                        root: classes.autoCompleteRoot,
                                        inputRoot: classes.inputRootV1
                                    }}
                                    id="select-driver-list"
                                    name="driver"
                                    size="small"
                                    // getOptionSelected={(option, value) => option.id === value.id}
                                    // open={true}
                                    onChange={(event, newValue) => {
                                        if (typeof newValue === 'string') {
                                            // timeout to avoid instant validation of the dialog's form.
                                            setTimeout(() => {
                                                setDriverValue(null);
                                                toggleAddDriverOpen(true);
                                            });
                                        } else if (newValue && newValue.inputValue) {
                                            setDriverValue(null);
                                            toggleAddDriverOpen(true);
                                        } else if (newValue && newValue.inputValue === '') {
                                            setDriverValue(null);
                                            toggleAddDriverOpen(true);
                                        } else {
                                            setDriverValue(newValue && newValue.id ? newValue.id : null);
                                        }
                                        setDriverFlow("add");

                                    }}
                                    required={true}
                                    autoHighlight
                                    options={fuelCardDriverList ? fuelCardDriverList : []}
                                    selectOnFocus
                                    clearOnBlur
                                    getOptionValue={option => option.id}
                                    getOptionLabel={(option) => {
                                        // e.g value selected with enter, right from the input
                                        if (typeof option === 'string') {
                                            return '';
                                        }
                                        if (option.inputValue || !option.id) {
                                            return '';
                                        }
                                        // return option && option.name ? option.name : ''
                                        if (option && option.contactNumber) {
                                            return `${option.name}  ` + decodeHtml("&#9679;") + `  ${option.contactNumber}`
                                        } else {
                                            return option && option.name ? option.name : ''
                                        }
                                    }}
                                    disableCloseOnSelect={false}
                                    filterOptions={(options, params) => {
                                        const filtered = filter(options, params);
                                        if (params.inputValue && (params.inputValue.trim()).length > 1) {
                                            // setNewDriverName(params.inputValue)
                                            // setVerifyDriver({ name: params.inputValue })
                                            setVerifyDriver(params.inputValue)
                                        }
                                        filtered.unshift({
                                            inputValue: params.inputValue,
                                            name: params.inputValue && params.inputValue.length > 1 ? `Add Details for <span style="color: black !important">"${params.inputValue}"</span>` : `Add New Driver`,
                                        });
                                        return filtered;
                                    }}
                                    filterSelectedOptions
                                    renderOption={(option, { selected, inputValue }) => {
                                        let matchesName, matchesNumber;
                                        let partsName, partsNumber;
                                        matchesName = match(option.name, inputValue);
                                        partsName = parse(option.name, matchesName);
                                        matchesNumber = match(option.contactNumber, inputValue);
                                        partsNumber = parse(option.contactNumber, matchesNumber);

                                        if (option && option.id) {
                                            return (
                                                <div className={classes.driverListItem}>
                                                    {partsName.map((part, index) => {
                                                        return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#5170f0' : '#0b1323' }}>
                                                            {part.text}
                                                        </span>
                                                        )
                                                    })}
                                                    <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                                    {option.contactNumber ?
                                                        (<>
                                                            {partsNumber.map((part, index) => {
                                                                return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#5170f0' : '#0b1323' }}>
                                                                    {part.text}
                                                                </span>
                                                                )
                                                            })}
                                                        </>)
                                                        :
                                                        (
                                                            <span>--</span>
                                                        )
                                                    }
                                                </div>
                                            );

                                        } else {
                                            return (
                                                <div className={classes.driverAddListItem}>
                                                    <AddPersonIcon className={classes.addPersonIcon} />
                                                    <span dangerouslySetInnerHTML={{ __html: option.name }}></span>
                                                    <ChevronRightIcon className={classes.cherveRightIcon} />
                                                </div>
                                            );
                                        }

                                    }}

                                    textFieldProps={
                                        {
                                            placeholder: "Select a Driver",
                                            variant: "outlined",
                                            margin: 'normal',
                                        }
                                    }
                                    multiple={false}
                                />
                            }
                            <FormHelperText className={classes.helperText}>Driver Details are important. You can change the Driver later</FormHelperText>
                        </div>
                    </>
                )

            }
        ]
    }

    const validate = values => {

        const errors = {};

        if ((!values.driver)) {
            errors.driver = 'Please Select a Driver';
        }

        if (values.driver) {
            setDataFlag(true)
        } else {
            setDataFlag(false)
        }

        return errors;
    };

    const onSubmit = values => {

        if (dataFlag) {

            const driverIdValue = values && values.driver ? values.driver : null
            let vehicleIdValue;

            if (fromSingleTruck) {
                vehicleIdValue = truckInfo && truckInfo.id ? truckInfo.id : ""
            } else {
                vehicleIdValue = truckInfo && truckInfo.vehicleId ? truckInfo.vehicleId : ""
            }

            const updateVehicleData = {
                driverId: driverIdValue
            }

            const fuelCardData = {
                driverId: driverIdValue,
                vehicleId: vehicleIdValue
            }

            // Calling update vehicle API only when driver is not present for a truck or if driver is changed
            if ((truckInfo.driverId != driverIdValue) || (truckInfo.driverId != null)) {
                dispatchUpdateVehicle(vehicleIdValue, updateVehicleData,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log("Driver Details Dialog Dweb", "Updated Vehicle successfully");
                            dispatchGenerateFuelCard(fuelCardData,
                                (data) => {
                                    if (data && data.status && data.status.code == 200) {
                                        logger.log("Driver Details Dialog Dweb", "Fuel card generated successfully")
                                        onClose();
                                        if (data.response && data.response.fuelBrokerId) {
                                            goToSingleDieselCard(data.response.fuelBrokerId);
                                        }
                                    }
                                },
                                () => {
                                    logger.log("Driver Details Dialog Dweb", "Fuel card generation failed")
                                }
                            )
                        }
                    },
                    () => {
                        logger.log("Driver Details Dialog Dweb", "Update vehicle failed");
                    }
                )
            } else {

                dispatchGenerateFuelCard(fuelCardData,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log("Driver Details Dialog Dweb", "Fuel card generated successfully")
                            onClose();
                            if (data.response && data.response.fuelBrokerId) {
                                goToSingleDieselCard(data.response.fuelBrokerId);
                            }
                        }
                    },
                    () => {
                        logger.log("Driver Details Dialog Dweb", "Fuel card generation failed")
                    }
                )

            }
        }
    }

    const goToSingleDieselCard = (fuelBrokerId) => {
        let vehicleIdValue;

        if (fromSingleTruck) {
            vehicleIdValue = truckInfo && truckInfo.id ? truckInfo.id : ""
        } else {
            vehicleIdValue = truckInfo && truckInfo.vehicleId ? truckInfo.vehicleId : ""
        }

        history.push({
            pathname: `/diesel-card/single-diesel-card/${vehicleIdValue}/${fuelBrokerId ? fuelBrokerId : ""}`,
            state: {
                id: 1,
                pageTitle: "Diesel Card",
                vehicleNumber: vehicleNumberArray
            }
        })
    }

    const handleRecallDriverList = () => {
        dispatchGetDieselCardDriverList(
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Driver Deatils Dialog", "Get Diesel Card Drivers List Successfull");
                }
            },
            () => {
                logger.log("Driver Deatils Dialog", "Get Diesel Card Drivers List Failed");
            }
        )
    }

    const handleAddDriverClose = () => {
        toggleAddDriverOpen(false)
        // setNewDriverName("");
        setVerifyDriver(null);
        setDriverFlow(null);
        if (driverFlow == "verify") {
            handleClose();
        }
    }

    const handleDriverSave = (response) => {
        vehicle.fuelCardDriverList = [];
        setFuelCardDriverList([]);
        handleRecallDriverList();
        toggleAddDriverOpen(false);
        setDriverValue(response && response.id ? response.id : null);
        setVerifyDriver(null);
        setDriverFlow(null);
    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xs'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-party-dialog-title" open={dialogOpen}
                classes={{ paperScrollPaper: classes.brV1 }}
            >
                <DialogTitle id="add-driver-detail-title" onClose={handleClose}>
                    Driver Details
                </DialogTitle>

                <DialogContent dividers className={classes.dialogContent}>

                    <div className={classes.divContainer}>
                        <div className={classes.divTitle}>Truck No.</div>
                        <div className={classes.truckNumberContainer}>
                            {
                                vehicleNumberArray.map((truckNumber, index) => (
                                    <div className={index != 0 ? classes.mlV1 : ""}>{truckNumber}</div>
                                ))
                            }

                        </div>
                    </div>

                    <Form
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />

                </DialogContent>

                <DialogActions>
                    <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
                        Close
                    </Button>
                    <Button className={!dataFlag ? classes.disableCta : classes.saveCta} type="submit" variant="contained"
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* *********************************** Add Driver Dialog *********************************** */}
            {addDriverOpen && <AddEditNewDriver open={addDriverOpen} onClose={handleAddDriverClose} onConfirm={handleDriverSave} driverFlowValue={driverFlow} verifyDriverInfo={verifyDriver} />}
        </>
    )
}
// defaultName={}
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetDieselCardDriverList: (onSuccess, onError) => {
        dispatch(getDieselCardDriverList(onSuccess, onError))
    },
    dispatchGenerateFuelCard: (data, onSuccess, onError) => {
        dispatch(generateFuelCard(data, onSuccess, onError))
    },
    dispatchUpdateVehicle: (vehicleId, data, onSuccess, onError) => {
        dispatch(updateVehicle3(vehicleId, data, onSuccess, onError))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(DriverDetailsDialog)
